<template>
  <form class="login-form">
    <v-text-field
      v-model="state.email"
      label="Email"
      required
      type="email"
      variant="outlined"
      prepend-inner-icon="mdi-email"
      density="comfortable"
      class="mb-3"
      @keydown.enter="onClickLogin"
    ></v-text-field>
    <v-text-field
      v-model="state.password"
      label="Password"
      required
      :type="showPassword ? 'text' : 'password'"
      variant="outlined"
      prepend-inner-icon="mdi-lock"
      :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      density="comfortable"
      class="mb-2"
      @click:append-inner="showPassword = !showPassword"
      @keydown.enter="onClickLogin"
    ></v-text-field>

    <div class="text-right mb-4">
      <RouterLink :to="URLs.PAGE_AUTH_PASSWORD_RESET" class="text-decoration-none text-error">
        Forgot Password?
      </RouterLink>
    </div>

    <v-btn
      block
      size="large"
      color="primary"
      variant="elevated"
      @click="onClickLogin"
      :loading="state.loading"
      class="mb-4"
    >
      Sign In
    </v-btn>

    <v-divider class="my-4"></v-divider>

    <div class="text-center">
      <span class="text-body-2">Don't have an account?</span>
      <RouterLink :to="URLs.PAGE_AUTH_REGISTER" class="text-decoration-none text-primary ml-2">
        Sign Up
      </RouterLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { URLs } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { useCustomerStore } from "@/stores/customer";
import { makeAlert } from "@/utils";
import { computed, ref } from "vue";
import { useRouter, useRoute } from "vue-router";

const emit = defineEmits<{
  "login-success": [];
}>();

const authStore = useAuthStore();
const customerStore = useCustomerStore();
const router = useRouter();
const route = useRoute();
const user = computed(() => authStore.user);

const state = ref({
  email: "",
  password: "",
  loading: false
});

const showPassword = ref(false);

const onClickLogin = async () => {
  state.value.loading = true;
  const response = await authStore.login({
    email: state.value.email,
    password: state.value.password
  });
  if (response.status) {
    await customerStore.fetchCustomers(user.value?.id!);

    if (route.query.callback_url) {
      emit("login-success");
    } else {
      router.push(URLs.PAGE_CUSTOMER_LIST);
    }
  } else {
    makeAlert(response.message, "error");
    console.log(response);
    if (response.type === "UserNotConfirmedException") {
      router.push({
        path: URLs.PAGE_AUTH_CONFIRM_REGISTER,
        query: { email: state.value.email }
      });
    }
  }
  state.value.loading = false;
};
</script>
